var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegaleyseLogoTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.9 48.3",
    style: {
      enableBackground: "new 0 0 141.9 48.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2B5BE2;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-horizontal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,15.1 0,17.7 1.7,17.7 1.7,31.6 11,31.6 11,29 4.7,29 4.7,15.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.5,25h3v2.9c-0.7,0.8-1.8,1.2-2.8,1.1c-2.2,0-3-1.3-3-3.4V21c0-2.1,0.7-3.4,2.9-3.4c1.3,0,2.5,0.7,3,1.9 l2.3-1.2c-0.8-2.2-3-3.5-5.3-3.4c-4.2,0-5.9,2.6-5.9,6.4v4.2c0,3.8,1.7,6.4,5.9,6.4c2.3,0.1,4.5-1,5.7-3v-6.4h-5.8V25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.5,15.1v2.6h1.4l-4.5,14h3l1.2-3.7h5.2l1.1,3.6h3l-5.3-16.5L52.5,15.1z M54.3,25.3l1.8-6.1h0.1l1.8,6.1 H54.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.1,15.1 67.1,17.7 68.8,17.7 68.8,31.6 78.1,31.6 78.1,29 71.7,29 71.7,15.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "98.3,15.1 98.3,17.7 100,17.7 103.8,25.4 103.8,31.6 106.8,31.6 106.8,25.4 111.7,15.1 108.6,15.1  105.3,22.5 105.2,22.5 102,15.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.5,19.5c0-1.1,0.5-1.9,2.3-1.9c1.3,0.1,2.6,0.4,3.7,1.1l1.3-2.2c-1.4-1-3.1-1.6-4.9-1.6 c-3.1,0-5.3,1.5-5.3,4.7c0,5.8,7.8,3.5,7.8,7.5c0,1.1-0.8,2.1-2.8,2.1c-1.5-0.1-2.9-0.5-4.2-1.3l-1.3,2.1c1.7,1.2,3.7,1.8,5.7,1.8 c3.2,0,5.5-1.8,5.5-4.9C126.3,20.8,118.5,22.6,118.5,19.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "130.8,15.1 130.8,17.7 132.6,17.7 132.6,31.6 141.9,31.6 141.9,29 135.6,29 135.6,24.5 141.3,24.5  141.3,21.9 135.6,21.9 135.6,17.7 141.9,17.7 141.9,15.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.4,15.1 15.4,17.7 17.1,17.7 17.1,31.6 26.4,31.6 26.4,29 20.1,29 20.1,24.5 25.8,24.5 25.8,21.9  20.1,21.9 20.1,17.7 26.4,17.7 26.4,15.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "82.4,15.1 82.4,17.7 84.1,17.7 84.1,31.6 93.4,31.6 93.4,29 87.1,29 87.1,24.5 92.9,24.5 92.9,21.9  87.1,21.9 87.1,17.7 93.4,17.7 93.4,15.1  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegaleyseLogoTxt);
export default __webpack_public_path__ + "static/media/legaleyse-logo-txt.9627aab1c76ab59f64188b764f3cc065.svg";
export { ForwardRef as ReactComponent };